import React, { useState, useEffect } from 'react';
import Lottie from 'react-lottie-player';
import lottieJson from 'animation/no-data.json';
import { Link } from 'react-router-dom';
import { slugToTitleCase } from 'config/libraries';

export const NoData = ({slug}) => {

    const [FadeClassName, setFadeClassName] = useState('fade-costum hide');
    const [PageName, setPageName] = useState('Data');

    useEffect(() => {
        setFadeClassName('fade-costum hide')

        setTimeout(() => {
            setFadeClassName('fade-costum')
        }, 300);
        setPageName(slugToTitleCase(slug));
        return () => {
            setFadeClassName('fade-costum hide')
        };
    }, [slug]);

    return (
        <div className={FadeClassName}>
            <div className="jl_single_style2">
                <div className="single_post_entry_content single_bellow_left_align jl_top_single_title jl_top_title_feature">
                    <div className="centered-no-data-static-page">
                        <Lottie loop animationData={lottieJson} play style={{ width: 250, height: 250 }}/>
                        <h1 className="single_post_title_main post-no-data">Oops!.. {PageName} Tidak Ditemukan</h1>
                        <p className='hint-no-data'>Tidak ada data atau apapun di halaman ini. Hubungi admin untuk informasi selengkapnya</p>
                    </div>
                </div>
            </div>
            <div className="clearfix" ></div>
            <div className="single_tag_share centered-single-tag-share" style={{ float: 'none' }}>
                <div className="tag-cat">
                    <ul className="single_post_tag_layout">
                        <li><Link to={'/'} rel="portal">portal</Link></li>
                        <li><Link to={'/home'} rel="home">home</Link></li>
                        <li><Link to={'/infografis'} rel="infografis">infografis</Link></li>
                        <li><Link to={'/kritikdansaran'} rel="kritikdansaran">kritik dan saran</Link></li>
                    </ul>
                </div>
            </div>
        </div>
    )
};